/**
 * Product URLs are collection-free (`/products/handle`), so Shopify never populates
 * the `collection` object on a product page. Liquid therefore falls back to the
 * product's first real collection, which ignores where the shopper actually came from.
 *
 * This carries the clicked-from collection across that navigation in sessionStorage
 * and rewrites the breadcrumb to match. On a cold load — shared link, direct hit,
 * new tab — nothing is stored and the server-rendered fallback stands.
 */
(() => {
  const STORAGE_KEY = 'kik:breadcrumb-collection';

  const pathOf = (url) => {
    try {
      return new URL(url, window.location.origin).pathname;
    } catch {
      return null;
    }
  };

  document.addEventListener('click', (event) => {
    const card = event.target.closest('a[data-kik-collection-url]');
    if (!card) return;

    const product = pathOf(card.href);
    if (!product) return;

    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          product,
          url: card.dataset.kikCollectionUrl,
          title: card.dataset.kikCollectionTitle,
        })
      );
    } catch {
      // Private browsing or a full quota — the Liquid fallback still renders.
    }
  });

  const crumb = document.querySelector('.breadcrumb__list a[href^="/collections/"]');
  if (!crumb) return;

  let stored;
  try {
    stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
  } catch {
    return;
  }

  if (!stored || !stored.url || !stored.title) return;
  if (stored.product !== window.location.pathname) return;

  crumb.href = stored.url;
  crumb.textContent = stored.title;
})();
